import React, { useContext, useEffect, useState } from "react";
import {
  CardContent,
  Container,
  LinearProgress,
  Paper,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import makeStyles from '@mui/styles/makeStyles';
import { grey } from "@mui/material/colors";
import moment from "moment";
// import messages from "../services/messages";
import messages from "../services/messages";
import LanguageContext from "../LanguageContext";
import useMediaQuery from "@mui/material/useMediaQuery";
import PopUp from "./PopUp";
import LeadService from "../services/LeadService";
import firebase from "../firebase";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "8px",
    display: "block",
    // display: "flex",
    // justifyContent:"space-between"
  },
  barColorPrimary: (props) => ({
    backgroundColor: props.msgcolor,
  }),
  colorPrimary: (props) => ({
    backgroundColor: "#DCDCDC",
  }),
  mainOuterCard: {
    backgroundColor: "#FFF8E9",
    // backgroundImage: `url(${"../icons/referral-en.jpg"})`,
    // backgroundRepeat: "no-repeat",

    marginTop: "10px",
    textAlign: "center",
    height: "90%",
  },
  innerDivcard: {
    height: "65px",
    width: "65px",
    backgroundColor: "grey",
  },
  textFreemium: {
    fontWeight: "400",
    margin: "13px 14px",
    lineHeight: "21.79px",
  },
  textStartedOn: {
    fontWeight: "400",
    color: "#999999",
    lineHeight: "16px",
  },
  textEndsOn: {
    fontWeight: "400",
    color: "#999999",
    lineHeight: "16px",
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
  textInvite: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    fontWeight: "400",
    marginTop: "10px",

    textAlign: "center",
    "@media (max-width: 1200px)": {
      marginTop: "20px",
    },
  },
  textStartDate: {
    fontWeight: "700",
    color: "#000",
    lineHeight: "16px",
  },
  textContinueBenifits: {
    fontWeight: "400",
    lineHeight: "16.34px",
    display: "inline-block",
  },
  textClass_qna: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#9d2123",
  },
  iframe: {
    width: 500,
    height: 600,
    "@media (max-width: 500px)": {
      width: 300,
    },
  },
  form: {
    height: 600,
    width: 400,
    "@media (max-width: 1200px)": {
      marginTop: "50px",
    },
  },
}));

export default function ImgMediaCard(props) {
  const smallScreen = useMediaQuery("(max-width:300px) and (min-width:0px)");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [totalDays, setTotalDays] = useState();
  const [leftDays, setLeftDays] = useState();
  const [percent, setPercent] = useState();
  const [daydif, setDayDif] = useState(3);
  const [message, setMessage] = useState(null);
  const [msgcolor, setMsgColor] = useState();
  const [attendedClasses, setAttendedClasses] = useState(23);
  const [qna, setQna] = useState(3);
  const classes = useStyles({ msgcolor });
  const language = useContext(LanguageContext);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [googleFormLink, setGoogleFormLink] = useState();
  const [renewPopup, setRenewPopup] = useState(false);
  const [visibleCard, setVisibleCard] = useState(false);
  const [validResponse, setValidResponse] = useState(false);
  const [planLength, setPlanLength] = useState(null);
  const [expired, setExpired] = useState(false);
  const [showRefCard, setShowRefCard] = useState(false);

  useEffect(() => {
    if (props.userData) {
      setValidResponse(true);
      let validResponse = true;
      const start = moment.unix(props.userData.subscription_start).format("ll");
      const end = moment.unix(props.userData.subscription_end).format("ll");
      setStartDate(start);
      setEndDate(end);

      let startVar = moment(start);
      let endVar = moment(end);

      const diff = endVar.diff(startVar, "days");

      setPlanLength(diff);
      let timeFormat = moment().format("ll");
      let left = moment(timeFormat);
      let totalDays = endVar.diff(startVar, "days");
      let leftDays = endVar.diff(left, "days");
      setTotalDays(totalDays);
      setLeftDays(leftDays);
      //change the logic of daydif, first logic calculate from current date now it calculate from end date
      let dayDiffVar = Math.abs(endVar.diff(moment(), "days"));
      setDayDif(dayDiffVar);

      let percentageVar = calcPercent(totalDays, leftDays);

      if (percentageVar <= 50) {
        let message = messages["referralcard.active"][language];
        if (message && message.length > 0) {
          setMessage(message);
          setMsgColor(`#4CAF50`);
        }
      } else if (percentageVar > 50 && percentageVar < 70) {
        let message = messages["referralcard.active"][language];
        if (message && message.length > 0) {
          setMessage(message);
          setMsgColor(`#FFB41F`);
        }
      } else if (percentageVar >= 70 && percentageVar < 100) {
        if (dayDiffVar <= 5 && percentageVar >= 95) {
          let message = messages["referralcard.expireinxDays"][language];
          if (message && message.length > 0) {
            message = message.replace("X", dayDiffVar);
            setMessage(message);
            setMsgColor(`#E53539`);
          }
        } else {
          let message = messages["referralcard.expiringSoon"][language];
          if (message && message.length > 0) {
            setMessage(message);
            setMsgColor(`#E53935`);
          }
        }
      } else if (percentageVar === 100) {
        let message = messages["referralcard.expired"][language];
        if (message && message.length > 0) {
          setMessage(message);
          setMsgColor("#E53935");
          setExpired(true);
        }
      }

      if (moment(startVar).isBefore(endVar) && validResponse) {
        setVisibleCard(true);
      }
    }
  }, [props.userData, language]);

  useEffect(() => {
    //for language and images
    if (language === "mr") {
      setGoogleFormLink(
        "https://docs.google.com/forms/d/e/1FAIpQLSehfptqbUn5339IlsvzQthSismxXRWPOFzUzJ8O1nkZ7KDLiQ/viewform?embedded=true"
      );
    } else if (language === "en") {
      setGoogleFormLink(
        "https://docs.google.com/forms/d/e/1FAIpQLScnocELUe65FEs9u3lbkS_fLUeut1bMMB73EP7_4F3sIQu0Hg/viewform?embedded=true"
      );
    } else if (language === "gu") {
      setGoogleFormLink(
        "https://docs.google.com/forms/d/e/1FAIpQLSejQWmuweL9p4rEK3Ltvpwc_jOJKSYebEngWmC9tACmlNkh6g/viewform?embedded=true"
      );
    } else if (language === "hi") {
      setGoogleFormLink(
        "https://docs.google.com/forms/d/e/1FAIpQLSckhMSlaWkzzpDi5Smh1BxAsSiD1T6BaBhvz5b_aUQ3PzJFlA/viewform?embedded=true"
      );
    }
  }, [language]);

  const calcPercent = (total, left) => {
    let percentage = ((total - left) / total) * 100;
    //here added logic for if percentage value is >100 then set 100 else percentage value, previous substract from 100 and it didn't work for some case
    if (percentage > 100) {
      setPercent(100);
    } else {
      setPercent(percentage);
    }
    return percentage;
  };
  const handleModalClose = () => {
    setOpenPopUp(false);
  };

  const handleRenewOpen = () => {
    setRenewPopup(true);
    LeadService.registerLead(
      props.state,
      props.mobile,
      "User wants to renew gold subscription"
    );
    firebase.analytics().logEvent("renew_clicked", {
      mobile: props.mobile,
      state: props.state,
      user_type: props.userType,
      user_source: props?.userSource,
    });
  };

  const renewSubscription = () => {};

  const handleRenewClose = () => [setRenewPopup(false)];

  return <>
    <Container>
      <PopUp
        openPopUp={openPopUp}
        setOpenPopUp={setOpenPopUp}
        onClose={handleModalClose}
      >
        {
          <iframe
            src={googleFormLink}
            // width="400"
            // height="600"
            className={classes.iframe}
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading…
          </iframe>
        }
      </PopUp>
      <PopUp
        openPopUp={renewPopup}
        onClose={handleRenewClose}
        closeIcon={false}
      >
        <div
          style={{
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {messages["dashboard.leadRegistrationSuccess.message"][language]}
          <Button
            onClick={handleRenewClose}
            variant="contained"
            disableElevation={true}
            style={{
              backgroundColor: "#9D2123",
              color: grey[50],
              fontWeight: "700",
              width: "80%",
              marginTop: "20px",
            }}
          >
            {messages["dashboard.leadRegistrationSuccess.okay"][language]}
          </Button>
        </div>
      </PopUp>
      <Grid className={classes.root} container spacing={3}>
        {visibleCard &&
          showRefCard &&
          props.cardVisibility(
            <Grid item xs={12} lg={6}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginTop: "15px",
                }}
              >
                <img
                  src={"icons/flat.svg"}
                  alt="coin-logo"
                  style={{ height: "28px" }}
                />
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    marginLeft: "2%",
                    fontFamily: "Roboto",
                  }}
                >
                  {messages["referralcard.refernearnHeading"][language]}
                </Typography>
              </div>
              <Card elevation={0} className={classes.mainOuterCard}>
                <CardContent>
                  <Grid
                    xs
                    container
                    justifyContent={smallScreen ? "center" : "space-around"}
                    alignItems="center"
                    direction={smallScreen ? "column" : "row"}
                  >
                    <img
                      alt={""}
                      src={`../icons/referral-${language}.png`}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid container justifyContent="center" alignItems="center">
                    <Typography
                      className={classes.textInvite}
                      variant={"body2"}
                    >
                      {messages["referralcard.invitetext"][language]}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    justifyContent={smallScreen ? "center" : "space-around"}
                    alignItems="center"
                    direction="row"
                    style={{ marginTop: "2%" }}
                  >
                    {/* <Grid item xs={6} sm={4}>
                  <Button
                    variant="contained"
                    disableElevation={true}
                    style={{
                      color: red.A700,
                      backgroundColor: "transparent",
                      fontWeight: "700",
                    }}
                  >
                    Learn More
                  </Button>
                </Grid> */}

                    <Grid item xs={12} sm={10}>
                      <Button
                        variant="contained"
                        disableElevation={true}
                        style={{
                          backgroundColor: "#9D2123",
                          color: grey[50],
                          fontWeight: "700",
                          width: "100%",
                        }}
                        onClick={() => {
                          setOpenPopUp(true);
                        }}
                      >
                        {
                          messages["referralcard.addfriendsbuttontext"][
                            language
                          ]
                        }
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}

        {visibleCard && props.cardVisibility && (
          <Grid item xs={12} lg={6}>
            <Card style={{ backgroundColor: "transparent" }} elevation={0}>
              <div style={{ display: "flex", justifyContent: "flex-start" }}>
                <img
                  src={"icons/coin_1.svg"}
                  alt="coin-logo"
                  style={{ height: "28px" }}
                />
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    marginLeft: "2%",
                  }}
                >
                  {messages["referralcard.title"][language]}
                </Typography>
              </div>
              <Paper elevation={0}>
                <Grid style={{ marginTop: "10px" }} item>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      marginTop: "2%",
                    }}
                  >
                    <Typography
                      display="inline"
                      variant="h6"
                      className={classes.textFreemium}
                    >
                      {planLength <= 30
                        ? messages["referralcard.freemium"][language]
                        : messages["referralcard.plan"][language]}
                      {/* {messages["referralcard.freemium"][language]} */}
                    </Typography>
                    {message && (
                      <Button
                        style={{
                          backgroundColor: `${msgcolor}`,
                          color: "#fff",
                          borderRadius: "34px",
                          margin: "13px 14px",
                          lineHeight: "16.34px",
                          fontWeight: "700",
                          fontSize: "12px",
                        }}
                        disabled
                        size="medium"
                      >
                        {message}
                      </Button>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Grid item style={{ margin: "0 14px" }}>
                      <Typography
                        style={{ fontSize: "12px" }}
                        className={classes.textStartedOn}
                      >
                        {messages["referralcard.startDate"][language]}
                      </Typography>
                      <Typography
                        style={{ fontSize: "14px" }}
                        className={classes.textStartDate}
                      >
                        {startDate}
                      </Typography>
                    </Grid>
                    <Grid item sm md></Grid>
                    <Grid item style={{ margin: "0 14px" }}>
                      <Typography
                        style={{ fontSize: "12px" }}
                        className={classes.textEndsOn}
                      >
                        {messages["referralcard.endDate"][language]}
                      </Typography>
                      <Typography
                        style={{
                          fontWeight: "700",
                          color: "#000",
                          lineHeight: "16px",
                          fontSize: "14px",
                        }}
                      >
                        {endDate}
                      </Typography>
                    </Grid>
                  </div>
                  <div
                    style={{
                      paddingBottom: "10px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LinearProgress
                      classes={{
                        bar: classes.barColorPrimary,
                        root: classes.colorPrimary,
                      }}
                      value={percent}
                      variant="determinate"
                      style={{
                        width: "98%",
                        margin: "13px 0px",
                        height: "5px",
                      }}
                      valueBuffer={50}
                    />
                  </div>
                  {(daydif <= 5 && percent >= 95) || leftDays <= 0 ? (
                    <div
                      style={{
                        padding: "13px 14px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#FFF8E9",
                      }}
                    >
                      <Typography className={classes.textContinueBenifits}>
                        {!expired
                          ? messages["referralcard.goldEnding"][language]
                          : messages["referralcard.expiredLine"][language]}
                      </Typography>
                      <Button
                        onClick={handleRenewOpen}
                        variant="contained"
                        disableElevation={true}
                        style={{
                          backgroundColor: "#9D2123",
                          color: grey[50],
                          fontWeight: "400",
                          marginBottom: "1%",
                        }}
                      >
                        {messages["referralcard.renewSubscription"][language]}
                      </Button>
                    </div>
                  ) : null}
                </Grid>
              </Paper>
            </Card>
          </Grid>
        )}
      </Grid>
    </Container>
  </>;
}
